export default function ToolbarButton(props) {
    return <button type="button" tabIndex="-1" {...props} />;
}
